import { setCookie } from "../helpers/utils";
import { cookieToken } from "../constants";
import { BRAND } from "../api";

export interface ILogin {
    authenticity_token: string | null,
    user: {
        email: string,
        password: string
    }
}

export interface IRequestOptions {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH',
  credentials?: 'include',
  headers?: {
    'Content-Type': string,
    'accept': string,
    'X-Requested-With'?: string,
    'ap-brand'?: string,
  },
  body?: any
}

export const RequestOptions = (method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH', body?: any):IRequestOptions  => {
  return {
    method: method,
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
      "accept": "application/json",
      "ap-brand": BRAND,
      //"X-Requested-With": "XMLHttpRequest",
    },
    body,
  }
}

export const handleResponse = (response: any) => {
  const xsrf_token = response.headers.get('xsrf-token');

  if (!!xsrf_token) {
    if (!xsrf_token.indexOf('{"')) {
      setCookie(cookieToken, Object.keys(JSON.parse(xsrf_token))[0]);
    } else {
      setCookie(cookieToken, xsrf_token);
    }
  }

  return Promise.resolve(response)
}
